import { createEvent, createStore } from 'effector';
import { MessageInstance } from '@features/socket-chats-reworked/types/common';

export const $messagesForForward = createStore<MessageInstance[]>([]);
export const changeMessagesForForward = createEvent<MessageInstance[]>();
